import mainStyle from "./mainStyle.module.scss";
import { ReactComponent as CheckBoxDefault } from "assets/images/icons/checkbox_default.svg";
import { ReactComponent as CheckBoxFilled } from "assets/images/icons/checkbox_fiilled.svg";
import { ReactComponent as CheckBoxClear } from "assets/images/icons/checkbox_clear.svg";

import icon_snmp from "assets/images/icons/icn_Info_solid.svg";
import icn_btn_rediscover from "assets/images/icons/icn_btn_rediscover.svg";
import btn_locked from "assets/images/icons/btn_Locked.svg";
import btn_unlocked from "assets/images/icons/btn_Unlock_hover.svg";

import { Box, Checkbox } from "@mui/material";

import { getDefaultCheckboxProp } from "./theme";
import { protocolTypeOption, authStateOption, } from "./const";

const addDeviceColumns = (
  columnHelper, disableCheckbox, toggleDeviceSelection,
  scanningDone, devices, toggleAllDeviceSelection
) => {
  const checkedCount = devices.filter(device => device.checked).length;

  const isDeterminate = () => {
    if (checkedCount === 0) {
      return false;
    }

    return true
  };

  const isAllChecked = () => {
    const firstCheckDevice = devices.find((device) => device.checked === true);
    const checkedSameAuthCount = devices.filter(device => device.authStatus === firstCheckDevice?.authStatus).length;

    if (!scanningDone || checkedCount === 0 || checkedCount !== checkedSameAuthCount) {
      return false;
    }

    return true;
  }

  return [
    columnHelper.accessor('checkbox', {
      id: 'checkbox',
      size: 50,
      enableSorting: false,
      enableResizing: false,
      header: () => {
        if (checkedCount === 0) {
          return null;
        }

        return (
          <Box display="flex" alignItems="center" justifyContent="center" style={{ width: '100%', marginLeft: '-6px' }}>
            <Checkbox
              icon={
                <CheckBoxDefault
                  style={{ width: "24px", height: "24px" }}
                />
              }
              indeterminateIcon={
                <CheckBoxClear
                  style={{ width: "24px", height: "24px" }}
                />
              }
              checkedIcon={
                <CheckBoxFilled
                  style={{ width: "24px", height: "24px" }}
                />
              }
              indeterminate={!isAllChecked() && isDeterminate()}
              checked={isAllChecked()}
              onMouseDown={(e) => e.preventDefault()}
              onPointerDown={(e) => e.stopPropagation()}
              onClick={(e) => {
                e.stopPropagation();
              }}
              onChange={(e, checked) => {
                e.stopPropagation();

                if (checkedCount === 0) {
                  return;
                }
                toggleAllDeviceSelection(checked);
              }}
              sx={{ ...getDefaultCheckboxProp().sx }}
            />
          </Box>

        );
      },
      cell: info => {
        const device = info.row.original;
        return (
          <Box display="flex" alignItems="center" justifyContent="center">
            <Checkbox
              edge="start"
              icon={
                <CheckBoxDefault
                  style={{ width: "24px", height: "24px" }}
                />
              }
              checkedIcon={
                <CheckBoxFilled
                  style={{ width: "24px", height: "24px" }}
                />
              }
              disabled={disableCheckbox(device)}
              checked={device.checked}
              onChange={() => { toggleDeviceSelection(device.macAddress) }}
              onClick={(e) => e.stopPropagation()}
              sx={{ ...getDefaultCheckboxProp().sx }}
            />
          </Box>

        );
      }
    }),
    columnHelper.accessor('status.value', {
      header: 'Status',
      meta: {},
      size: '100',
      cell: info => {
        const device = info.row.original;
        const isUnauthSnmp = device.protocolType === protocolTypeOption.snmp && device.authStatus !== authStateOption.passed;
        const showWarningIcon = isUnauthSnmp;

        return (
          <Box display="flex" alignItems="center">
            <Box className={`${mainStyle["chip-name"]} ${mainStyle[`${device.status.value}-chip`]}`}>
              {device.status.label}
            </Box>
            {showWarningIcon && (
              <Box display="flex" alignItems="center" style={{ marginLeft: '10px' }}>
                <img src={icon_snmp} alt="" />
              </Box>
            )}
          </Box>
        );
      }
    }),
    columnHelper.accessor('authStatus', {
      header: 'Auth',
      meta: {},
      size: '75',
      cell: info => {
        const device = info.row.original;
        return (
          <>
            {
              device.authStatus === null && (
                <>
                  <img
                    src={icn_btn_rediscover}
                    alt=""
                    style={{ width: '20px', height: '20px', marginRight: '5px' }}
                  />
                </>
              )
            }
            {
              device.authStatus === authStateOption.passed && (
                <>
                  <img
                    src={btn_unlocked}
                    alt=""
                    style={{ width: '20px', height: '20px', marginRight: '5px' }}
                  />
                </>
              )
            }
            {
              device.authStatus === authStateOption.failed && (
                <>
                  <img
                    src={btn_locked}
                    alt=""
                    style={{ width: '20px', height: '20px', marginRight: '5px' }}
                  />
                </>
              )
            }
          </>
        );
      }
    }),
    columnHelper.accessor('modelName', {
      header: 'Model Name',
      meta: {},
      cell: info => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {info.getValue()}
        </Box>
      )
    }),
    columnHelper.accessor('macAddress', {
      header: 'MAC Address',
      meta: {},
      cell: info => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {info.getValue()}
        </Box>
      )
    }),
    columnHelper.accessor('ipAddress', {
      header: 'IP Address',
      meta: {},
      cell: info => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {info.getValue()}
        </Box>
      )
    }),
  ];
}

export default addDeviceColumns;